import React from "react";
import styles from "./ClientSearch.module.css";
import { useMemo, useState, useCallback, useRef, useEffect } from "react";
import {
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
  Form
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import ClientDocuments from "./ClientDocuments/ClientDocuments";
import { CustomButton } from "reusable-components/CustomButtonComponent/button";
import { getClients, searchClient } from "./ClientSearch.service";
import { ClientDataItem, ClientSearchProps } from "./ClientSearch.types";
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";



/**
 * ClientSearch Component
 */
const ClientSearch: React.FC<ClientSearchProps> = ({ transporter }) => {

  const [clientSearching, setClientSearching] = useState<boolean>(false);
  const [refreshGrid, setRefreshGrid] = useState<boolean>(false);
  const [clientData, setClientData] = useState<ClientDataItem[]>([]);
  const [clientNameOrId, setClientNameOrId] = useState<string>("");
  const [clientDocumentsShow, setClientDocumentsShow] = useState<boolean>(false);
  const [clientMasterId, setClientMasterId] = useState<number | null>(null);
  const [clientId, setClientId] = useState<string | null>(null);
  const [clientName, setClientName] = useState<string | null>(null);
  const gridRef = useRef(null);
  const [key, setKey] = useState<number | string | undefined>(undefined);

  const getAllClients = useCallback(async () => {
    setRefreshGrid(true)
    const allClients: ClientDataItem[] = await getClients();
    if (allClients !== undefined) {
      setClientData(allClients);
      setKey(allClients.length);

    }
    setRefreshGrid(false)
  }, [])

  useEffect(() => {
    getAllClients()
    console.log("INSIDE use effect")
  }, [getAllClients])


  const getSearchedClientData = async (clientNameOrId: string) => {
    setClientSearching(true)
    setRefreshGrid(true)
    const payload = {
      ClientDetail: clientNameOrId
    }
    const searchedClients: ClientDataItem[] = await searchClient(payload);
    if (searchedClients !== undefined) {
      setClientData(searchedClients);
      setKey(JSON.stringify(searchedClients.map(c => c.ClientMasterId)));
    }
    setClientSearching(false)
    setRefreshGrid(false)
  }

  const DocumentsCellRenderer: React.FC<any> = ({ rowData, setClientDocumentsShow }) => {
    const uploadDocuments = () => {
      setClientMasterId(rowData?.ClientMasterId);
      setClientId(rowData?.ClientId);
      setClientName(rowData?.ClientName);
      setClientDocumentsShow(true)
    };

    return rowData ? (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id="button-tooltip">Upload Documents</Tooltip>}
        >
          <span className={styles.tooltipWrapper}>
            <Button
              className={styles.actionButton}
              onClick={uploadDocuments}
            >
              <Icon.CloudUpload className={styles.iconsmall} />
            </Button>
          </span>
        </OverlayTrigger>
      </>
    ) : (
      <></>
    )
  }

  const defaultClientSearchColumnDefs = [
    {
      headerName: "Client Id",
      field: "ClientId",
      flex: 1,
      sortable: false
    },
    {
      headerName: "Client Name",
      field: "ClientName",
      flex: 2,
      sortable: false
    },
    {
      headerName: "Client Type",
      field: "ClientType",
      flex: 1,
      sortable: false,
    },
    {
      headerName: "Office",
      field: "Office",
      flex: 2,
      sortable: false,
    },
    {
      headerName: "Action",
      field: "",
      cellRenderer: DocumentsCellRenderer,
      cellRendererParams: (params: any) => ({
        rowData: params.data,
        setClientDocumentsShow: setClientDocumentsShow
      }),
      pinned: "right",
      maxWidth: 80,
      minWidth: 80,
      sortable: false,
      suppressMenu: true,  
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true, 
    }
  ];

  const onClientNameOrIdChange = (event: any) => {
    setClientNameOrId(event.target.value);
  }

  const [defaultColDefs, setDefaultColDefs] = useState<any[]>(defaultClientSearchColumnDefs);

  const searchClientByNameOrId = () => {
    getSearchedClientData(clientNameOrId)
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      getSearchedClientData(clientNameOrId)
    }
  };
  return (
    <>
      {clientDocumentsShow && (
        <ClientDocuments
          show={clientDocumentsShow}
          onHide={() => setClientDocumentsShow(false)}
          clientmasterid={clientMasterId}
          clientid={clientId}
          clientname={clientName}
          transporter={transporter}         
        />
      )}
      <Row className='no-gutter'>
        <p className={`display-6 ${styles.noMarginBottom}`}>
          Clients
        </p>
      </Row>
      <Row className='no-gutter'>
        <Col md={12} className="d-flex justify-content-end" style={{ float: "right" }}>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <Form.Control
              type="text"
              className="form-control custom-input mb-1"
              placeholder="Client Name or Client Id"
              value={clientNameOrId}
              onChange={onClientNameOrIdChange}
              id=""
              style={{ width: "250px" }}
              onKeyDown={handleKeyPress} 
            />            
            <CustomButton
                progress={clientSearching}
                onclick={() => searchClientByNameOrId()}
                content={clientSearching ? "Searching" : "Search"}
            />
          </div>
        </Col>
        <Col md={12} style={{ minHeight: "79vh" }}>          
          <CygnusGrid
            key={key}            
            columnDefs={defaultColDefs}
            fetchData={async () => ({
              records: clientData,
              totalCount: clientData.length,
            })}
            dataIdentifier="ClientMasterId"
            rowSelection={"single"}
            onLoadingChange={setRefreshGrid}
            cachedIsLoading={refreshGrid}
            cachedData={clientData}
            setCachedData={setClientData}
            rowModelType="clientSide"
          />
        </Col>
      </Row>
    </>
  );
};

export default ClientSearch;